import tpl from './serverApi.html';
import "./serverApi.css";

class ServerApi {
    constructor(container, opts) {
        this.container = container;
        this.container.innerHTML = tpl;
    }
}

export {
    ServerApi
}